module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_9016.a44ff6b4.png";